import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

const FOOTER_LINKS = [
  { id: "browse", href: "/archive", label: "Browse Archive" },
  { id: "submit", href: "/submit", label: "Submit a Topic" },
  { id: "about", href: "/about", label: "About / Methodology" },
];

const TRUST_LINKS = [
  { id: "faq", href: "/faq", label: "FAQ" },
  { id: "editorial", href: "/editorial-standards", label: "Editorial Standards" },
  { id: "legal", href: "/legal", label: "Legal" },
  { id: "correction", href: "/submit?mode=correction", label: "Submit a Correction" },
];

export const Footer = () => (
  <footer className="border-t border-[#2D2A26] mt-10 md:mt-24 bg-[#0F0F0F]">
    <div className="max-w-7xl mx-auto px-4 md:px-12 py-7 md:py-10 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
      <div className="col-span-2">
        <div className="font-display text-lg md:text-xl mb-2 md:mb-3">THE ARCHIVE</div>
        <p className="text-[13px] md:text-sm text-[#A39E93] leading-relaxed max-w-md mb-3 md:mb-4">
          An independent dossier of the world's most contested narratives —
          sourced, dissected, declassified.
        </p>
        <div className="flex gap-3 text-xs text-[#A39E93] leading-relaxed max-w-md">
          <AlertTriangle size={16} className="shrink-0 text-[#D92D20] mt-0.5" />
          <p>
            Material is editorial commentary aggregated from public sources.
            Always read the originals. Truth is rarely tidy.
          </p>
        </div>
      </div>
      <div>
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#757065] mb-2.5 md:mb-3">
          // Index
        </div>
        <ul className="space-y-1.5 md:space-y-2 text-[13px] md:text-sm text-[#A39E93]">
          {FOOTER_LINKS.map((l) => (
            <li key={l.id}>
              <Link to={l.href} className="hover:text-[#D92D20] inline-block py-0.5" data-testid={`footer-${l.id}`}>{l.label}</Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#757065] mb-2.5 md:mb-3">
          // Trust
        </div>
        <ul className="space-y-1.5 md:space-y-2 text-[13px] md:text-sm text-[#A39E93]">
          {TRUST_LINKS.map((l) => (
            <li key={l.id}>
              <Link to={l.href} className="hover:text-[#D92D20] inline-block py-0.5" data-testid={`footer-${l.id}`}>{l.label}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className="border-t border-[#2D2A26] py-3 md:py-4 text-center font-mono text-[10px] tracking-widest text-[#454038]">
      ARCHIVE.LOG // {new Date().getFullYear()} // ALL RECORDS PRESERVED
    </div>
  </footer>
);

export default Footer;
